module.exports = __webpack_public_path__ + "static/media/top-brand-11.857984a0.png";